<template functional>
    <div :class="data.staticClass"
         v-on:click.stop.prevent="listeners['outside']">
        <div :class="props.className">
            <span :class="`${props.className}__close`"
                  v-on:click.stop.prevent="listeners['close']">
                <svg width="18" height="18">
                    <use :xlink:href="`/assets/symbols/icons.svg?v=${props.iconsSetVersion}#im-close`"></use>
                </svg>
            </span>
            <span :class="`${props.className}__title`">
                {{props.deliveryTimeInfo}}
            </span>
            <span :class="`${props.className}__desc`">
                Wydłużony czas dostawy
            </span>
            <span :class="`${props.className}__cta btn btn-block`"
                  v-on:click.stop.prevent="listeners['cta']">
                Ok, rozumiem
            </span>
            <span :class="`${props.className}__tick`"></span>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'dm-dropshipping-info',
        props: {
            className: String,
            deliveryTimeInfo: String,
            iconsSetVersion: String,
        },
    };
</script>
